import React, { useEffect, useState, useRef } from 'react';
import { supabase } from './supabaseClient';

export default function CreateWallpaper() {
  const [characters, setCharacters] = useState([]);
  const [selected, setSelected] = useState([]);
  const [universes, setUniverses] = useState([]);
  const [creators, setCreators] = useState([]);
  const [selectedUniverse, setSelectedUniverse] = useState('');
  const [selectedCreator, setSelectedCreator] = useState('');
  const canvasRef = useRef(null);
  const [wallpaperGenerated, setWallpaperGenerated] = useState(false);

  useEffect(() => {
    fetchFilters();
    fetchCharacters();
  }, []);

  useEffect(() => {
    fetchCharacters();
  }, [selectedUniverse, selectedCreator]);

  const fetchFilters = async () => {
    const { data: universeData } = await supabase.from('universes').select('*');
    const { data: creatorData } = await supabase.from('creadores').select('*');
    if (universeData) setUniverses(universeData);
    if (creatorData) setCreators(creatorData);
  };

  const fetchCharacters = async () => {
    let query = supabase.from('characters').select('image');

    if (selectedUniverse) {
      query = query.eq('universo', selectedUniverse);
    }

    if (selectedCreator) {
      query = query.eq('creador_url', selectedCreator);
    }

    const { data, error } = await query;
    if (!error && data.length > 0) {
      setCharacters(data);
    } else {
      const { data: allData } = await supabase.from('characters').select('image');
      if (allData) {
        const shuffled = allData.sort(() => 0.5 - Math.random()).slice(0, 500);
        setCharacters(shuffled);
      }
    }
    setSelected([]);
    setWallpaperGenerated(false);
  };

  const toggleSelection = (url) => {
    if (selected.includes(url)) {
      setSelected(selected.filter((item) => item !== url));
    } else if (selected.length < 8) {
      setSelected([...selected, url]);
    }
  };

  const generateWallpaper = async () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = 1080;
    canvas.height = 1920;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const imgWidth = 540;
    const imgHeight = 480;

    for (let i = 0; i < selected.length; i++) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = selected[i];
      await new Promise((res) => {
        img.onload = () => {
          const x = (i % 2) * imgWidth;
          const y = Math.floor(i / 2) * imgHeight;
          ctx.drawImage(img, x, y, imgWidth, imgHeight);
          res();
        };
      });
    }

    setWallpaperGenerated(true);
    setSelected([]); // Reset selection but keep wallpaper
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>📱 Create Your NUBBI Wallpaper</h2>
      <p>Select up to 8 Nubbis:</p>

      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem', marginBottom: '1rem' }}>
        <select onChange={(e) => setSelectedUniverse(e.target.value)} value={selectedUniverse}>
          <option value=''>🌍 All Universes</option>
          {universes.map((u) => (
            <option key={u.code} value={u.code}>{u.name}</option>
          ))}
        </select>

        <select onChange={(e) => setSelectedCreator(e.target.value)} value={selectedCreator}>
          <option value=''>👤 All Creators</option>
          {creators.map((c) => (
            <option key={c.url} value={c.url}>{c.nombre_completo}</option>
          ))}
        </select>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
        {characters.map((char, idx) => (
          <img
            key={idx}
            src={char.image}
            alt="nubbi"
            onClick={() => toggleSelection(char.image)}
            style={{
              width: '100px',
              height: '100px',
              objectFit: 'cover',
              border: selected.includes(char.image) ? '4px solid #00cc66' : '2px solid #ccc',
              borderRadius: '10px',
              cursor: 'pointer'
            }}
          />
        ))}
      </div>

      <button
        onClick={generateWallpaper}
        disabled={selected.length !== 8}
        style={{
          marginTop: '1.5rem',
          padding: '10px 20px',
          fontSize: '1rem',
          fontWeight: 'bold',
          background: selected.length === 8 ? '#00cc66' : '#ccc',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          cursor: selected.length === 8 ? 'pointer' : 'not-allowed'
        }}
      >
        Generate Wallpaper for phone
      </button>

      <div style={{ marginTop: '2rem' }}>
        <canvas ref={canvasRef} style={{ width: '270px', height: '480px', border: '1px solid #ccc', borderRadius: '12px' }} />
        {wallpaperGenerated && <p style={{ fontSize: '0.9rem', color: '#666' }}>Take a screenshot or right-click to save</p>}
      </div>
    </div>
  );
}
